import { Component, Inject, Optional, OnInit,Input,Output,EventEmitter,ViewChild} from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import { DatePipe } from '@angular/common'
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl,FormGroup, FormBuilder } from '@angular/forms';
import { MatDrawer } from '@angular/material/sidenav';

import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';

import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';


@Component({
  selector: 'filtros-kri',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.scss'],
  providers:[DatePipe]
})

export class FiltrosKRIComponent {


  @Input() hideFechaInicio: boolean;
  @Input() hideFechaFin: boolean;
  @Input() filtro: FormGroup;
  @Input() evaluador: boolean;
  @Output("loadData") loadData: EventEmitter<any> = new EventEmitter();
  @Output() filterChange = new EventEmitter<FormGroup>();


  //estados: string[] = ['PRE_INICIADO','INICIADO','COMPLETADO','APROBADO','CERRADO'];
  estructuras: EstructuraJerarquica[] = [];
  duenos: any[] = [];
  usuarios: any[] = [];

  hoy:Date = new Date();
  fecha:FormControl = new FormControl((new Date()).toISOString());

  @ViewChild('drawer') sidenav: MatDrawer;

  constructor(
    public datepipe: DatePipe,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private serviceEstructuraJerarquica:EstructuraJerarquicaService,
    private userService:UsersService
    ) {
      //console.log(this.tipoUsuario);
    }

  clean():void{
    this.filtro = this._formBuilder.group({
      estructura: [],
      dueno: [],
      creador: [],
      fechaInicioDesde: [],
      fechaInicioHasta: [],
      fechaFinDesde: [],
      fechaFinHasta: []
    });
  }

  onSubmit():void{
    this.filterChange.emit(this.filtro);
    this.loadData.emit();
    this.sidenav.close();
  }

  close(reason: string): void {
    this.sidenav.close();
  }

  ngOnInit(): void {

    this.filtro = this._formBuilder.group({
      estructura: [],
      dueno: [],
      creador: [],
      fechaInicioDesde: [],
      fechaInicioHasta: [],
      fechaFinDesde: [],
      fechaFinHasta: []
    });

    this.estructuras= [];
    this.duenos= [];
    this.usuarios= [];

    this.serviceEstructuraJerarquica.getAll(0,1000).pipe().subscribe(req => {
      this.estructuras = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });
    });

    this.userService.getAll(0,1000).pipe().subscribe(req => {
      req.body.map( user => {

        var usr = {
          id: user.id,
          nombre: user.nombre,
          apellido: user.apellido,
          nombreCompleto: user.nombreCompleto,
          correoElectronico: user.correoElectronico,
          tipos: user.tipos,
          active: user.active
        };

        var esDueno = false;
        var esEvaluador = false;

        usr.tipos.forEach(element => {
          if(element.id==4)
            esDueno = true;
          if(element.id==7)
            esEvaluador=true;
        });

        this.usuarios.push(usr);

        if(esEvaluador && this.evaluador){
          this.duenos.push(usr);
        }else if(esDueno && !this.evaluador){
          this.duenos.push(usr);
        }



      });
    });
  }

  }
